function isMissingLogStreamError(error: unknown): boolean {
  if (!error || typeof error !== 'object') {
    return false;
  }

  const status = (error as { status?: unknown }).status;
  const errorCode = (error as { data?: { errorCode?: unknown } }).data?.errorCode;
  
  return (!!status && Number(status) === 400 && errorCode === 'LogStreamNotFound');
}

export default isMissingLogStreamError;
